//investmentTerms json is injected into page inline
$(document).on('turbolinks:load', function(){

    function updateOptions(){
        $("#finalize-btn").prop("disabled",false);
        $("#investment_error").removeClass("alert-danger");
        var amount = $("#investment_amount").val();
        var periodSelected = $("#schedule_select :selected").val();
        var termsLargeToSmall = investmentTerms.slice().reverse();
        for(var i=0; i<termsLargeToSmall.length; i++)
        {
            var term = termsLargeToSmall[i];
            if (parseFloat(amount) >= parseFloat(term.range_min)) {
                var periods = [];
                var interest = 0;
                if(term.interest_rate_monthly) {
                    periods.push('monthly');
                }
                if(term.interest_rate_quarterly) {
                    periods.push('quarterly');
                }
                if(term.interest_rate_yearly) {
                    periods.push('yearly');
                }
                if(!periodSelected || periods.indexOf(periodSelected) == -1) periodSelected = periods[0];
                var select = $('#schedule_select');
                select.empty();
                for (var p in periods) {
                    var pVal = periods[p];
                    $(select).append('<option '+ (pVal == periodSelected ? 'selected' : '') +' value=' + pVal +'>' + pVal.charAt(0).toUpperCase() + pVal.slice(1) +'</option>');
                }
                switch (periodSelected) {
                    case 'monthly':
                        interest = term.interest_rate_monthly;
                        break;
                    case 'quarterly':
                        interest = term.interest_rate_quarterly;
                        break;
                    case 'yearly':
                        interest = term.interest_rate_yearly;
                        break;
                }
                $('#term_length_years').val(term.term_length_years + 'yrs');
                $('#interest_rate').val(interest+'%');
                
                highlight_class = '#' + term.id + periodSelected;
                $(highlight_class).addClass('blue');
    
                break;
            }
        }
    }

    $("#investment_amount").change(function() {
        var val = $("#investment_amount").val();
        val = val.replace("$","");
        val = parseFloat(val);
        $(".blue").removeClass("blue");
        if(val >= termsMin && val <= 100000){
            updateOptions();
        }else{
            var error_select = $('#investment_error');
            $(error_select).addClass("alert-danger");

            $("#finalize-btn").prop("disabled",true);
            $('#schedule_select').empty();
            $('#term_length_years').val('');
            $('#interest_rate').val('');
        }
    });

    $("#schedule_select").change(function() {
        $(".blue").removeClass("blue");
        updateOptions();
    });

    $("#finalize-btn").click(function(){ 
        $("#exampleModal").css("display","");
        var val = $("#investment_amount").val();
        var bank = $("#bank_account").val();
        var year = $("#term_length_years").val().replace('yrs','');;
        var rate = $("#interest_rate").val();
        var term = $("#schedule_select").val().toLowerCase();;
        var text = "Confirm that you are initializing an investment by sending $" + val + " from your bank '" + bank + "' to Pfotzer Properties. This is a " + year + " year loan paid out " + term + " at " + rate + ".";
        $("#modal-text").text(text);
    });

    $("#close-modal2").click(function(){ 
        $("#exampleModal").css("display","none");
    });

    $("#finalize-investment-btn").click(function(){ 
        $("#exampleModal").css("display","none");
        $('#new_investment_form').get(0).submit();
    });

    $("#ssn-link").click(function(){ 
        $("#ssnModal").css("display","");
    });

    $("#close-modal3").click(function(){ 
        $("#ssnModal").css("display","none");
    });

});